import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import Overlay from '@ynap/overlay'

type Props = {
    country: string,
    shipModeCode: string
    onClose: () => void
    messages: any
}

const bem = new BEMHelper('PremierShippingPopup')

const PremierPopup = ({ country, shipModeCode, onClose, messages }: Props) => {
    const isPremierDaytime = shipModeCode === 'PREMIER_DAYTIME'

    return (
        <Overlay
            className={{ container: bem('overlay'), content: bem('content'), title: bem('title'), button: bem('close') }}
            title={messages.title({ isPremierDaytime: isPremierDaytime })}
            onClose={onClose}
        >
            <div className={bem('bannerImg')}></div>
            <ul>
                <li>
                    <span>{messages.benefits.title1({ isPremierDaytime: isPremierDaytime })}</span>
                    <p>{messages.benefits.description1({ isPremierDaytime: isPremierDaytime })}</p>
                </li>
                <li>
                    <span>{messages.benefits.title2()}</span>
                    <p>{messages.benefits.description2({country})}</p>
                </li>
                <li>
                    <span>{messages.benefits.title3()}</span>
                    <p>{messages.benefits.description3()}</p>
                </li>
            </ul>
        </Overlay>
    )
}

export default PremierPopup
